import {
  Component,
  OnInit,
  Renderer,
  ViewChild,
  ElementRef
} from "@angular/core";
// import { ROUTES } from '../../sidebar/sidebar.component';
import { Router } from "@angular/router";
import { Location } from "@angular/common";

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.css"]
})
export class NavbarComponent implements OnInit {
  label: String = "";
  constructor(private router: Router) {}

  ngOnInit() {
    console.log("GETTING URL", this.router.url);
    var url = this.router.url;
    let srt = url.split("/");

    if (srt[1] == "students") {
      this.label = "Students";
    } else if (srt[1] == "visitors") {
      this.label = "Add Visitor";
    } else if (srt[1] == "studentdetails") {
      this.label = "Student Details";
    }
  }
}
